import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ChevronLeft, Calendar, Tag } from "lucide-react";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import { SocialShareButtons } from "../components/SocialShareButtons";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const BlogPostPage = () => {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/blog/${slug}`)
      .then(res => setPost(res.data))
      .catch(() => navigate("/blog"))
      .finally(() => setLoading(false));
  }, [slug, navigate]);

  if (loading || !post) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="w-16 h-16 border-4 border-neon-cyan border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <div className="min-h-screen py-10 px-6" data-testid="blog-post-page">
      <div className="max-w-3xl mx-auto">
        <Button variant="ghost" onClick={() => navigate("/blog")} className="mb-6 text-zinc-400">
          <ChevronLeft className="w-4 h-4 mr-1" />Back to Blog
        </Button>

        {post.image_url && (
          <div className="w-full h-64 md:h-96 overflow-hidden mb-8">
            <img src={post.image_url} alt={post.title} className="w-full h-full object-cover" />
          </div>
        )}

        <h1 className="font-heading text-3xl md:text-4xl uppercase tracking-tight mb-4">{post.title}</h1>
        
        <div className="flex items-center gap-4 text-sm text-zinc-500 mb-6">
          <div className="flex items-center gap-1">
            <Calendar className="w-4 h-4" />
            {new Date(post.created_at).toLocaleDateString()}
          </div>
          <span>by {post.author_name}</span>
        </div>

        <div className="flex flex-wrap gap-2 mb-8">
          {post.tags?.map((tag, i) => (
            <Badge key={i} variant="outline" className="border-white/10">
              <Tag className="w-3 h-3 mr-1" />{tag}
            </Badge>
          ))}
        </div>

        <div className="prose prose-invert max-w-none text-zinc-300 leading-relaxed whitespace-pre-wrap mb-8">
          {post.content}
        </div>

        <div className="border-t border-white/10 pt-6">
          <SocialShareButtons title={post.title} url={window.location.href} />
        </div>
      </div>
    </div>
  );
};

export default BlogPostPage;
